module.exports = __webpack_public_path__ + "img/Partner_04.a866ffc2.png";